/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { type TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { SET_RECORDINGS_STATUS_DETAILS } from './recordings.types';

export interface IRecordingsStatus {
    maxAge: number;
    recordingsStatusMap: Map<string, string>;
}

export const setRecordingsStatusDetailsAction = ({
    maxAge,
    recordingsStatusMap,
}: IRecordingsStatus): TivoPayloadAction<IRecordingsStatus> => ({
    type: SET_RECORDINGS_STATUS_DETAILS,
    payload: { maxAge, recordingsStatusMap },
});
